/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Checklist item requirement: agent check (eg "check: 2 blank pages")
 * @export
 * @interface PaxCheckCheck
 */
export interface PaxCheckCheck {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckCheck
     */
    asText: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckCheck
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckCheck interface.
 */
export function instanceOfPaxCheckCheck(value: object): value is PaxCheckCheck {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckCheckFromJSON(json: any): PaxCheckCheck {
    return PaxCheckCheckFromJSONTyped(json, false);
}

export function PaxCheckCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckCheck {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'type': json['type'],
    };
}

export function PaxCheckCheckToJSON(json: any): PaxCheckCheck {
    return PaxCheckCheckToJSONTyped(json, false);
}

export function PaxCheckCheckToJSONTyped(value?: PaxCheckCheck | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'type': value['type'],
    };
}

